export const TypeAngles = {
    "Natural": 90,
    "Panoramic": 22,
    "Vitta": 90,
    "Delux": 22,
    "Classic": 90,
}